function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { Flex, BreadcrumbNav, Icon, icons } from '@tapresearch/ui/components';
import { useBreadcrumb } from '../../hook/useBreadcrumb';
export var BreadcrumbContainer = function() {
    var _useBreadcrumb = useBreadcrumb(), breadcrumb = _useBreadcrumb.breadcrumb, altContent = _useBreadcrumb.altContent;
    var _ref = altContent || {}, center = _ref.center, centerProps = _ref.centerProps, right = _ref.right, rightProps = _ref.rightProps;
    if (!breadcrumb.length && !altContent) return null;
    return /*#__PURE__*/ React.createElement(Flex, _object_spread({
        className: "breadcrumb"
    }, Styles.BreadcrumbContainer), /*#__PURE__*/ React.createElement(Flex, Styles.FlexColumn, /*#__PURE__*/ React.createElement(BreadcrumbNav, {
        color: "gray.800",
        items: breadcrumb,
        separator: /*#__PURE__*/ React.createElement(Icon, {
            boxSize: 7,
            icon: icons.fi.ChevronRight,
            color: "blue.500"
        })
    })), /*#__PURE__*/ React.createElement(Flex, _object_spread({}, Styles.FlexColumn, centerProps), center), /*#__PURE__*/ React.createElement(Flex, _object_spread(_object_spread_props(_object_spread({}, Styles.FlexColumn), {
        justify: 'flex-end'
    }), rightProps), right));
};
var Styles = {
    BreadcrumbContainer: {
        width: 'full',
        bg: 'white',
        maxW: 'none',
        px: 5,
        h: '100%',
        align: 'center',
        justify: 'space-between',
        sx: {
            ol: {
                display: 'flex',
                alignItems: 'stretch',
                h: '45px'
            },
            li: {
                alignItems: 'stretch',
                '> span:not(.chakra-text)': {
                    display: 'flex',
                    alignItems: 'center',
                    mx: 1
                }
            },
            a: {
                display: 'flex',
                alignItems: 'center',
                h: '100%',
                rounded: 'lg',
                _hover: {
                    textDecoration: 'none'
                }
            }
        }
    },
    FlexColumn: {
        flex: 1,
        align: 'center',
        h: '100%'
    }
};
